const DEVICE_COLORS = { desktop: "#0EA5E9", mobile: "#10B981", tablet: "#8B5CF6" };

export const DeviceBrowserWidget = ({ data, loading }) => {
  const devices = data?.device_breakdown || [];
  const browsers = data?.browser_breakdown || [];
  const deviceTotal = devices.reduce((s, d) => s + d.count, 0);
  const browserTotal = browsers.reduce((s, b) => s + b.count, 0);

  return (
    <div data-testid="device-browser-widget" className="bg-slate-900/80 border border-slate-800 rounded-xl p-5 shadow-lg backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Device &amp; Browser</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : deviceTotal === 0 ? (
        <p className="text-sm text-slate-500">No consented device data yet.</p>
      ) : (
        <div className="space-y-4">
          <div>
            <p className="text-xs font-mono text-slate-500 uppercase tracking-wider mb-2">Device</p>
            {devices.map((d) => (
              <div key={d.device} className="flex items-center gap-2 mb-1.5">
                <span className="text-xs text-slate-400 w-16 capitalize">{d.device}</span>
                <div className="flex-1 h-2 rounded-full bg-white/5 overflow-hidden">
                  <div className="h-full rounded-full" style={{ width: `${(d.count / deviceTotal) * 100}%`, backgroundColor: DEVICE_COLORS[d.device] || "#818CF8" }} />
                </div>
                <span className="text-xs text-slate-500 font-mono w-8 text-right">{d.count}</span>
              </div>
            ))}
          </div>
          {browserTotal > 0 && (
            <div>
              <p className="text-xs font-mono text-slate-500 uppercase tracking-wider mb-2">Browser</p>
              {browsers.map((b) => (
                <div key={b.browser} className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs text-slate-400 w-16">{b.browser}</span>
                  <div className="flex-1 h-2 rounded-full bg-white/5 overflow-hidden">
                    <div className="h-full rounded-full bg-amber-500" style={{ width: `${(b.count / browserTotal) * 100}%` }} />
                  </div>
                  <span className="text-xs text-slate-500 font-mono w-8 text-right">{b.count}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
